import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";

const Icon = (props) => {
  return (
    <FontAwesomeIcon {...props} icon={faRotateRight} />
  );
}

export default Icon;
